import { createAction } from "redux-actions";
import { createPromiseAction } from "../../utils/createPromiseAction";

export const GET_DAILY_QUEST_REQUEST = "brand/GET_DAILY_QUEST_REQUEST";
export const GET_DAILY_QUEST_SUCCESS = "brand/GET_DAILY_QUEST_SUCCESS";
export const ANSWER_DAILY_QUEST_REQUEST = "brand/ANSWER_DAILY_QUEST_REQUEST";
export const ANSWER_DAILY_QUEST_SUCCESS = "brand/ANSWER_DAILY_QUEST_SUCCESS";
export const SHOW_DAILY_QUEST_MODAL = "brand/SHOW_DAILY_QUEST_MODAL";
export const HIDE_DAILY_QUEST_MODAL = "brand/HIDE_DAILY_QUEST_MODAL";
export const SHOW_QUEST_ANIMATION = "brand/SHOW_QUEST_ANIMATION";
export const HIDE_QUEST_ANIMATION = "brand/HIDE_QUEST_ANIMATION";

export const dailyQuestActions = {
  getDailyQuest: createPromiseAction(GET_DAILY_QUEST_REQUEST),
  getDailyQuestSuccess: createAction(GET_DAILY_QUEST_SUCCESS),
  answerDailyQuest: createPromiseAction(ANSWER_DAILY_QUEST_REQUEST),
  answerDailyQuestSuccess: createAction(ANSWER_DAILY_QUEST_SUCCESS),
  hideDailyQuestModal: createAction(HIDE_DAILY_QUEST_MODAL),
  showDailyQuestModal: createAction(SHOW_DAILY_QUEST_MODAL),
  showQuestAnimation: createAction(SHOW_QUEST_ANIMATION),
  hideQuestAnimation: createAction(HIDE_QUEST_ANIMATION),
};
